import { render, staticRenderFns } from "./bankaTanimla.vue?vue&type=template&id=77c4dc98&scoped=true&"
import script from "./bankaTanimla.vue?vue&type=script&lang=js&"
export * from "./bankaTanimla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c4dc98",
  null
  
)

export default component.exports